// extracted by mini-css-extract-plugin
module.exports = {"loader":"RangeSlider_loader__2spdC","root":"RangeSlider_root__1fJsU","activeHandle":"RangeSlider_activeHandle__3apC2"};